import React, { Suspense } from 'react'

export default function withComponent(getComponent, fallback = null) {
  return WrappedComponent =>
    class ComponentWithComponent extends React.Component {
      static displayName = `withComponent(${WrappedComponent.displayName ||
        WrappedComponent.name})`

      constructor(props) {
        super(props)

        this.Component = React.lazy(() => {
          const component = getComponent()
          return component.then
            ? component
            : Promise.resolve({ default: component })
        })
      }

      render() {
        return (
          <Suspense fallback={fallback}>
            <WrappedComponent {...this.props} Component={this.Component} />
          </Suspense>
        )
      }
    }
}
